import { ErrorMessage } from 'components/ErrorMessage/ErrorMessage';
import { useMemo, useRef, useState } from 'react';
import { useEffect } from 'react';
import { ReactElement } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  RfUiAccordionCustom,
  RfUiButton,
  RfUiDatepicker,
  RfUiModal,
  RfUiMultiselect,
  RfUiSelect,
} from 'renfe-components';
import { createStructuredSelector } from 'reselect';
import {
  getCursosFilter,
  getEstadosCursos,
  getProvinciasCursos,
  getSociedadesCursos,
  removeCursosFilter,
} from 'store/cursos/actions';
import {
  makeSelectCursosFilterParsed,
  makeSelectEstadosCursosParsed,
  makeSelectProvinciasCursosParsed,
  makeSelectSociedadesCursosParsed,
} from 'store/cursos/selectors';
import { makeSelectFiltros, makeSelectNombreFiltro, makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected, makesSelectFiltrosParse } from 'store/usuarios/selectors';
import {
  getActualTime,
  getTodayFinishDate,
  getTodayMinusOneYearStartDate,
} from 'utils/dates-validators';
import { arrayToAPI } from 'utils/listUtils';
import { language } from 'utils/literals';
import 'scss/03_generic/literals.scss';
import { formatDateMax } from 'utils/dateTimeUtils';
import { isMobileOnly } from 'react-device-detect';
import { deleteSavedPagination } from 'utils/practiceUtils';
import { links } from '../index';
import { FilterContainer } from 'containers/filterContainer';
import { editarFiltroRequest, eliminarFiltroRequest, getFiltros, getFiltrosRequest, guardarFiltroRequest, removeFiltro, setFiltroFechaCreacion, setFiltroFechaModificacion, setFiltroId, setFiltroJson, setFiltroNombre, setFiltroNombrePagina } from 'store/usuarios/actions';
import { useHistory } from 'react-router';
import { RouteTypes } from 'consts';

const selectors = createStructuredSelector({
  profileActive: makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected(),
  sociedades: makeSelectSociedadesCursosParsed(),
  provincias: makeSelectProvinciasCursosParsed(),
  estados: makeSelectEstadosCursosParsed(),
  cursos: makeSelectCursosFilterParsed(),
  filtro: makeSelectFiltros(),
  filtros: makesSelectFiltrosParse(),
  nombreFiltro: makeSelectNombreFiltro(),
  cursosFiltro: makeSelectCursosFilterParsed(),
  sociedadesFiltro: makeSelectSociedadesCursosParsed(),
  estadosFiltro: makeSelectEstadosCursosParsed(),
  provinciasFiltro: makeSelectProvinciasCursosParsed(),

} as any);

const today = getTodayFinishDate().toString();

const iniFilter = {
  fechaInicio: getTodayMinusOneYearStartDate(),
  fechaFin: getTodayFinishDate(),
  sociedades: '',
  estados: '',
  cursos: '',
  provincias: '',
  filtro: ''
};

export const CursosFilter = ({ handleSubmit }): ReactElement => {
  const dispatch = useDispatch();
  const history = useHistory();
  const {
    profileActive,
    sociedades,
    provincias,
    estados,
    cursos,
    filtro,
    filtros,
    nombreFiltro,
    cursosFiltro,
    sociedadesFiltro,
    estadosFiltro,
    provinciasFiltro,
  } = useSelector<any, any>(selectors);
  const [selectedSociedades, setSelectedSociedades]: [any, any] = useState('');
  const [selectedProvincias, setSelectedProvincias]: [any, any] = useState('');
  const [selectedEstados, setSelectedEstados]: [any, any] = useState('');
  const [selectedCursos, setSelectedCursos]: [any, any] = useState('');
  const [selectedFechaDesde, setSelectedFechaDesde]: [any, any] = useState(
    getTodayMinusOneYearStartDate()
  );
  const [selectedFechaHasta, setSelectedFechaHasta]: [any, any] = useState(
    getTodayFinishDate()
  );

  const [errorFechaHasta, setErrorFechaHasta] = useState('');

  const filter: any = useRef(iniFilter);
  const initEstado: any = useRef(null);

  const [sociedadResetKey, setSociedadResetKey] = useState(0);
  const [provinciaResetKey, setProvinciaResetKey] = useState(0);
  const [estadoResetKey, setEstadoResetKey] = useState(0);
  const [cursoResetKey, setCursoResetKey] = useState(0);

  const resetSociedadPending = useRef(true);
  const resetProvinciaPending = useRef(true);
  const resetEstadoPending = useRef(true);
  const resetCursoPending = useRef(true);

  const hasMultiselectOptions = (options: any): boolean => {
    if (Array.isArray(options)) {
      return options.length > 0;
    }

    if (typeof options === 'string') {
      try {
        const parsedOptions = JSON.parse(options);

        return Array.isArray(parsedOptions) && parsedOptions.length > 0;
      } catch {
        return false;
      }
    }

    return false;
  };  

  useEffect(() => {
    if (
      resetSociedadPending.current &&
      hasMultiselectOptions(sociedades)
    ) {
      setSociedadResetKey(k => k + 1);
      resetSociedadPending.current = false;
    }
  }, [sociedades]);

  useEffect(() => {
    if (
      resetProvinciaPending.current &&
      hasMultiselectOptions(provincias)
    ) {
      setProvinciaResetKey(k => k + 1);
      resetProvinciaPending.current = false;
    }
  }, [provincias]);

  useEffect(() => {
    if (
      resetEstadoPending.current &&
      hasMultiselectOptions(estados)
    ) {
      setEstadoResetKey(k => k + 1);
      resetEstadoPending.current = false;
    }
  }, [estados]);

  useEffect(() => {
    if (
      resetCursoPending.current &&
      hasMultiselectOptions(cursos)
    ) {
      setCursoResetKey(k => k + 1);
      resetCursoPending.current = false;
    }
  }, [cursos]); 

  const handleSelectedSociedad = (e) => {
    const sociedades = arrayToAPI(e.detail);
    filter.current = {
      ...filter.current,
      sociedades,
      provincias: '',
      cursos: '',
    };
    setSelectedProvincias('[]');
    setSelectedCursos('[]');

    // Sociedad provoca nuevas opciones de Provincia y Curso
    resetProvinciaPending.current = true;
    resetCursoPending.current = true;

    dispatch(getProvinciasCursos({ sociedades }));
    dispatch(getCursosFilter(filter.current));
  };

  const handleSelectedProvincia = (e) => {
    const provincias = arrayToAPI(e.detail);
    filter.current = { ...filter.current, provincias, cursos: '' };
    setSelectedCursos('[]');

    // Provincia modifica las opciones de Curso
    resetCursoPending.current = true;

    dispatch(getCursosFilter(filter.current));
  };

  const handleSelectedEstado = (e) => {
    const estados = arrayToAPI(e.detail);

    filter.current = { ...filter.current, estados, cursos: '' };

    // Estado modifica las opciones disponibles de Curso
    resetCursoPending.current = true;

    // Volver a cargar los cursos aplicando los estados seleccionados
    dispatch(getCursosFilter(filter.current));
  };

  const handleSelectedCursos = (e) => {
    const cursos = arrayToAPI(e.detail);
    filter.current = { ...filter.current, cursos };
  };

  const handleSelectedFechaDesde = (e) => {
    setSelectedFechaDesde(e.detail);
    filter.current.fechaInicio = e.detail;
  };

  const handleSelectedFechaHasta = (e) => {
    setSelectedFechaHasta(formatDateMax(e.detail));
    filter.current.fechaFin = formatDateMax(e.detail);
  };

  const cleanFilters = () => {
    dispatch(removeCursosFilter());
    dispatch(removeFiltro());

    setSelectedOptionFilter(false);
    setIsFilterActive(false);
    setSelectedSociedades('[]');
    setSelectedProvincias('[]');
    setSelectedEstados(JSON.stringify([initEstado.current]));
    setSelectedCursos('[]');
    setSelectedFechaDesde(getTodayMinusOneYearStartDate());
    setSelectedFechaHasta(getTodayFinishDate());
    setSelectedFiltros('[]');

    filter.current = {
      ...iniFilter,
      fechaFin: getTodayFinishDate(),
      fechaInicio: getTodayMinusOneYearStartDate(),
      estados: initEstado.current.value,
    };

    // Las opciones de los cuatro multiselects se van a recargar.
    resetSociedadPending.current = true;
    resetProvinciaPending.current = true;
    resetEstadoPending.current = true;
    resetCursoPending.current = true;

    dispatch(getSociedadesCursos({}));
    dispatch(getProvinciasCursos({}));
    dispatch(getCursosFilter({}));
    dispatch(getEstadosCursos({}));
    handlerSubmitFilters();
  };

  const handlerSubmitFilters = () => {
    deleteSavedPagination(window.location.pathname);
    handleSubmit(filter.current);
  };

  useEffect(() => {
    const estadosArray = JSON.parse(estados);

    if (!estadosArray?.length) {
      return;
    }
    const estadoInit = estadosArray.find((estado) => estado.value === 'IN');
    initEstado.current = estadoInit;
    setSelectedEstados(JSON.stringify([estadoInit]));
    filter.current.estados = estadoInit.value;
  }, [estados]);

  useEffect(() => {
    if (selectedFechaDesde && selectedFechaHasta) {
      if (selectedFechaHasta < selectedFechaDesde) {
        setErrorFechaHasta(
          'La fecha de fin no puede ser anterior a la fecha de inicio'
        );
      } else {
        setErrorFechaHasta('');
      }
    } else if (selectedFechaDesde || selectedFechaHasta) {
      setErrorFechaHasta('Debes rellenar la otra fecha');
    } else {
      setErrorFechaHasta('');
    }
  }, [selectedFechaDesde, selectedFechaHasta]);

  useEffect(() => {
    if (profileActive) {
      dispatch(getSociedadesCursos({}));
      dispatch(getProvinciasCursos({}));
      dispatch(getEstadosCursos({}));
      dispatch(getCursosFilter({}));
    }
  }, [profileActive]);

  //Filtro
  const [selectedFiltros, setSelectedFiltros]: [any, any] = useState('');
  const [selectedFilterName, setSelectedFilterName] = useState('');
  const [modalCerradoFiltroGuardarType, setModalCerradoFiltroGuardarType] = useState('');
  const [modalCerradoFiltroEliminarType, setModalCerradoFiltroEliminarType] = useState('');
  const [modalCerradoFiltroEditarType, setModalCerradoFiltroEditarType] = useState('');
  const [selectedFilterId, setSelectedFilterId] = useState('');
  const [isFilterActive, setIsFilterActive] = useState(false);
  const [minDateFromFilter, setMinDateFromFilter] = useState('');
  const [maxDateFromFilter, setMaxDateFromFilter] = useState('');
  const [optionsFilter, setOptionsFilter] = useState('');
  const [selectedOptionFilter, setSelectedOptionFilter] = useState(false);

  const handleSelectedFiltros = (e: any) => {
    setSelectedOptionFilter(true);
    const filtroSeleccionado = e.detail;
    setSelectedFilterName(filtroSeleccionado.label);
    const filtroId = filtroSeleccionado.label.split(' - ')[0];
    setSelectedFilterId(filtroId);

    const filtroValue = JSON.parse(filtroSeleccionado.value);


    let parsedSociedades: { label: string; value: string; active?: string }[];
    try {
      parsedSociedades = typeof sociedadesFiltro === 'string' ? JSON.parse(sociedadesFiltro) : sociedadesFiltro;
    } catch (error) {
      parsedSociedades = [];
    }

    let updatedSociedades: { label: string; value: string; active: string }[] = [];
    if (Array.isArray(parsedSociedades)) {
      const uniqueSociedades = new Set<string>();
      updatedSociedades = parsedSociedades
        .filter((sociedad) => {
          return filtroValue.sociedades.split(',').includes(sociedad.value.toString());
        })
        .filter((sociedad) => {
          if (uniqueSociedades.has(sociedad.value)) {
            return false;
          } else {
            uniqueSociedades.add(sociedad.value);
            return true;
          }
        })
        .map((sociedad) => ({
          ...sociedad,
          active: 'true',
        }));
    }

    const filtroValueSociedades = filtroValue.sociedades.split(',');
    filtroValueSociedades.forEach((sociedadId: string) => {
      if (!updatedSociedades.some((sociedad) => sociedad.value === sociedadId)) {
        const sociedadPractica = parsedSociedades.find((sociedad) => sociedad.value === sociedadId);
        if (sociedadPractica) {
          updatedSociedades.push({
            label: `${sociedadId} - ${sociedadPractica.label.split(' - ')[1]}`,
            value: sociedadId,
            active: 'true',
          });
        }
      }
    });

    let parsedCursos: { label: string; value: string; active?: string }[] = [];
    try {
      parsedCursos = typeof cursosFiltro === 'string' ? JSON.parse(cursosFiltro) : cursosFiltro;
    } catch (error) {
      parsedCursos = [];
    }

    let updatedCursos: { label: string; value: string; active: string }[] = [];
    if (Array.isArray(parsedCursos)) {
      const uniqueCursos = new Set<string>();
      updatedCursos = parsedCursos
        .filter((curso) => {
          return filtroValue.cursos.split(',').includes(curso.value.toString());
        })
        .filter((curso) => {
          if (uniqueCursos.has(curso.value)) {
            return false;
          } else {
            uniqueCursos.add(curso.value);
            return true;
          }
        })
        .map((curso) => ({
          ...curso,
          active: 'true',
        }));
    }

    const filtroValueCursos = filtroValue.cursos.split(',');
    filtroValueCursos.forEach((cursoId: string) => {
      if (Array.isArray(parsedCursos) && !updatedCursos.some((curso) => curso.value === cursoId)) {
        const curso = parsedCursos.find((alumno) => alumno.value === cursoId);
        if (curso) {
          updatedCursos.push({
            label: `${cursoId} - ${curso.label.split(' - ')[1]}`,
            value: cursoId,
            active: 'true',
          });
        }
      }
    });

    let parsedEstados: { label: string; value: string }[] = [];
    try {
      parsedEstados = typeof estadosFiltro === 'string' ? JSON.parse(estadosFiltro) : estadosFiltro;
    } catch (error) {
      parsedEstados = [];
    }

    let updatedEstados: { label: string; value: string; active: string }[] = [];
    if (Array.isArray(parsedEstados)) {
      const uniqueEstados = new Set<string>();
      updatedEstados = parsedEstados
        .filter((estado) => filtroValue.estados.split(',').includes(estado.value))
        .filter((estado) => {
          if (uniqueEstados.has(estado.value)) {
            return false;
          } else {
            uniqueEstados.add(estado.value);
            return true;
          }
        })
        .map((estado) => ({
          label: estado.label,
          value: estado.value,
          active: 'true',
        }));
    }

    const filtroValueEstados = filtroValue.estados.split(',');
    filtroValueEstados.forEach((estadoId) => {
      if (!updatedEstados.some((estado) => estado.value === estadoId)) {
        const estadoPractica = parsedEstados.find((estado) => estado.value === estadoId);
        if (estadoPractica) {
          updatedEstados.push({
            label: estadoPractica.label,
            value: estadoId,
            active: 'true',
          });
        }
      }
    });

    let parsedProvincias: { label: string; value: string }[] = [];
    try {
      parsedProvincias = typeof provinciasFiltro === 'string' ? JSON.parse(provinciasFiltro) : provinciasFiltro;
    } catch (error) {
      parsedProvincias = [];
    }

    let updatedProvincias: { label: string; value: string; active: string }[] = [];
    if (Array.isArray(parsedProvincias)) {
      const uniqueProvincias = new Set<string>();
      updatedProvincias = parsedProvincias
        .filter((provincia) => filtroValue.provincias.split(',').includes(provincia.value))
        .filter((provincia) => {
          if (uniqueProvincias.has(provincia.value)) {
            return false;
          } else {
            uniqueProvincias.add(provincia.value);
            return true;
          }
        })
        .map((provincia) => ({
          label: provincia.label,
          value: provincia.value,
          active: 'true',
        }));
    }

    const filtroValueProvincias = filtroValue.provincias.split(',');
    filtroValueProvincias.forEach((provinciaId) => {
      if (!updatedProvincias.some((provincia) => provincia.value === provinciaId)) {
        const provinciaPractica = parsedProvincias.find((provincia) => provincia.value === provinciaId);
        if (provinciaPractica) {
          updatedProvincias.push({
            label: provinciaPractica.label,
            value: provinciaId,
            active: 'true',
          });
        }
      }
    });

    const minDateFromFilter = new Date(filtroValue.fechaInicio).getTime();
    const maxDateFromFilter = new Date(filtroValue.fechaFin).getTime();

    const combinedOptions = [
      ...updatedCursos,
      ...updatedSociedades,
      ...updatedEstados,
      ...updatedProvincias,
      minDateFromFilter,
      maxDateFromFilter,
    ];

    setOptionsFilter(JSON.stringify(combinedOptions));
    setMinDateFromFilter(JSON.stringify(minDateFromFilter));
    setMaxDateFromFilter(JSON.stringify(maxDateFromFilter));
    setIsFilterActive(true);

    filter.current = {
      cursos: filtroValue.cursos,
      sociedades: filtroValue.sociedades,
      estados: filtroValue.estados,
      provincias: filtroValue.provincias,
      fechaInicio: filtroValue.fechaInicio,
      fechaFin: filtroValue.fechaFin,
    };
  };

  const openModalGuardarFiltroCerrado = () => {
    setModalCerradoFiltroGuardarType('empty');
  }

  const closeModalGuardarFiltroCerrado = () => {
    setModalCerradoFiltroGuardarType('');
  };

  const handleChangeFiltroNombre = (e: string) => {
    dispatch(setFiltroNombre(e));
  };

  const handleClickConfirmFilterButton = () => {
    const filtroDatos = filter.current;
    const nombrePag = links[0].label;
    const pagina = dispatch(setFiltroNombrePagina(nombrePag));
    const filtroJson = dispatch(setFiltroJson(filtroDatos));
    dispatch(guardarFiltroRequest(pagina, filtroJson));
    history.push(RouteTypes.AUDIT);
    history.push(RouteTypes.COURSE);
  };

  const filterNameAdd: boolean = useMemo(() => {
    return !!nombreFiltro;
  }, [nombreFiltro]);

  //Editar filtro
  const openModalEditarFiltroCerrado = () => {
    setModalCerradoFiltroEditarType('confirm');
  };

  const closeModalEditarFiltroCerrado = () => {
    setModalCerradoFiltroEditarType('');
  };

  const confirmModalEditarFiltroCerrado = (filterName: string) => {
    handleClickEditarFiltroButton(filterName);
  };

  const handleClickEditarFiltroButton = (filterName: string) => {
    setModalCerradoFiltroEditarType('');

    const filtroDatos = filter.current;
    const filtroIdString = String(selectedFilterId);
    const nombrePag = links[0].label;
    const pagina = dispatch(setFiltroNombrePagina(nombrePag));
    const filtroJson = dispatch(setFiltroJson(filtroDatos));
    const nombreFiltro = filterName.split(' - ')[1];
    const filtroSeleccionado = filtro.find(filtro => filtro.NOMBRE_FILTRO === nombreFiltro);
    const fechaCreacion = filtroSeleccionado.FECHA_CREACION;
    const fechaModificacion = getActualTime();

    dispatch(setFiltroNombre(nombreFiltro));
    dispatch(setFiltroId(filtroIdString));
    dispatch(setFiltroFechaCreacion(fechaCreacion));
    dispatch(setFiltroFechaModificacion(fechaModificacion));
    dispatch(editarFiltroRequest(filtroJson, pagina));

    history.push(RouteTypes.AUDIT);
    history.push(RouteTypes.COURSE);
  }

  //Eliminar filtro
  const openModalEliminarFiltroCerrado = () => {
    setModalCerradoFiltroEliminarType('confirm');
  }

  const closeModalEliminarFiltroCerrado = () => {
    setModalCerradoFiltroEliminarType('');
  }

  const confirmModalEliminarFiltroCerrado = () => {
    handleClickEliminarFiltroButton();
  };

  const handleClickEliminarFiltroButton = () => {
    setModalCerradoFiltroEliminarType('');
    const filtroIdString = String(selectedFilterId);
    dispatch(setFiltroId(filtroIdString));
    dispatch(eliminarFiltroRequest(filtroIdString));
    history.push(RouteTypes.AUDIT);
    history.push(RouteTypes.COURSE);
  }

  return (
    <>
      <RfUiAccordionCustom className="rf-accordion">
        <h2 className="rf-title rf-accordion__title">Filtrado</h2>
        <button
          className="rf-accordion__button rf-ui-accordion-custom__button"
          data-toggle="collapse"
          aria-expanded="false"
        >
          Mostrar filtros
        </button>
        <form
          id="courseForm"
          className="rf-accordion__content rf-ui-accordion-custom__panel collapse"
        >
          <div className="rf-box">
            {(profileActive?.ID_PERFIL === '511' || profileActive?.ID_PERFIL === '611') && (
              <div className="rf-practice-list__input-container">
                <RfUiMultiselect
                  key={`multiselect-sociedades-${sociedadResetKey}`}
                  withoutOptionsText={language.validations.noOptions}
                  textError={language.validations.multiselectEmpty}
                  textLabel="Sociedad"
                  placeholder="Seleccione sociedad"
                  defaultChecks={selectedSociedades}
                  options={sociedades}
                  onOptionSelected={(e: any) => {
                    handleSelectedSociedad(e);
                  }}
                  optionsFilter={optionsFilter}
                  isFilterActive={isFilterActive}
                />
              </div>
            )}
            <div className="rf-practice-list__input-container rf-practice-list__input-container--desde-reducer-mb">
              <RfUiMultiselect
                key={`multiselect-provincias-${provinciaResetKey}`}
                textLabel="Provincia"
                withoutOptionsText={language.validations.noOptions}
                textError={language.validations.multiselectEmpty}
                placeholder="Seleccione provincia"
                defaultChecks={selectedProvincias}
                options={provincias}
                onOptionSelected={(e: any) => {
                  handleSelectedProvincia(e);
                }}
                optionsFilter={optionsFilter}
                isFilterActive={isFilterActive}
              />
            </div>

            <div className="rf-box__child">
              <div className="literals-date">
                <span>Fecha de inicio de curso</span>
              </div>
              <div className="rf-practice-detail__input-container rf-practice-list__input-container--pr rf-practice-list__input-container--hasta-reducer-mb">
                <RfUiDatepicker
                  moment-locale="es"
                  labelInput="Desde"
                  disabled={false}
                  onDateSelected={(e: any) => {
                    handleSelectedFechaDesde(e);
                  }}
                  defaultDateFrom={isFilterActive ? minDateFromFilter : selectedFechaDesde}
                  defaultMaxDateFrom={today}
                ></RfUiDatepicker>
              </div>
            </div>
            <div className="rf-box__child">
              <div className="literals-date">
                <span>Fecha de Sistema</span>
              </div>
              <div className="rf-practice-detail__input-container rf-practice-list__input-container--section-reducer-mb">
                <RfUiDatepicker
                  moment-locale="es"
                  labelInput="Hasta"
                  disabled={false}
                  onDateSelected={(e: any) => {
                    handleSelectedFechaHasta(e);
                  }}
                  defaultDateFrom={isFilterActive ? maxDateFromFilter : selectedFechaHasta}
                  defaultMaxDateFrom={today}
                ></RfUiDatepicker>
                <ErrorMessage message={errorFechaHasta}></ErrorMessage>
              </div>
            </div>
          </div>
          <div className="rf-box">
            <div className="rf-practice-list__input-container">
              <RfUiMultiselect
                key={`multiselect-estados-${estadoResetKey}`}
                textLabel="Estado"
                withoutOptionsText={language.validations.noOptions}
                textError={language.validations.multiselectEmpty}
                placeholder="Seleccione estado"
                defaultChecksRemake={selectedEstados}
                options={estados}
                onOptionSelected={(e: any) => {
                  handleSelectedEstado(e);
                }}
                optionsFilter={optionsFilter}
                isFilterActive={isFilterActive}
              />
            </div>
            <div className="rf-practice-list__input-container">
              <RfUiMultiselect
                key={`multiselect-cursos-${cursoResetKey}`}
                textLabel="Curso"
                withoutOptionsText={language.validations.noOptions}
                textError={language.validations.multiselectEmpty}
                placeholder="Seleccione curso"
                defaultChecks={selectedCursos}
                options={cursos}
                onOptionSelected={(e: any) => {
                  handleSelectedCursos(e);
                }}
                optionsFilter={optionsFilter}
                isFilterActive={isFilterActive}
              />
            </div>
            <div className="rf-practice-list__input-container">
              <RfUiSelect
                withoutOptionsText={language.validations.noOptions}
                textError={language.validations.multiselectEmpty}
                options={filtros}
                defaultValue={selectedFiltros}
                label="Filtros"
                onOptionActive={handleSelectedFiltros}
                placeHolder="Seleccione Filtro"
                optionFilter={selectedOptionFilter}
                onEdit={openModalEditarFiltroCerrado}
                onDelete={openModalEliminarFiltroCerrado}
              />
            </div>
          </div>
          <div
            className={`rf-flex rf-justify-end rf-align-center rf-text-align-right
             ${isMobileOnly
                ? 'rf-block--mobile rf-text-align-center--mobile'
                : ''
              }`}
          >
            <RfUiButton
              text="Guardar filtros"
              text-help="Guardar filtros"
              aspect="secondary"
              onButtonClick={() => {
                openModalGuardarFiltroCerrado();
              }}
            >
              {' '}
            </RfUiButton>
            <RfUiButton
              text="Limpiar filtros"
              text-help="Limpiar filtros"
              aspect="secondary"
              onButtonClick={() => {
                cleanFilters();
              }}
            >
              {' '}
            </RfUiButton>
            <RfUiButton
              text="Filtrar"
              type="button"
              aspect="primary"
              className="rf-button rf-margin-left-30"
              onButtonClick={() => {
                handlerSubmitFilters();
              }}
              disabled={!!errorFechaHasta}
            >
              {' '}
            </RfUiButton>
          </div>
        </form>
        <div>
          <RfUiModal
            title-Modal={'Nombre filtro'}
            id-modal="empty"
            modal-type={modalCerradoFiltroGuardarType}
            slot-content={true}
            onModalClose={(e: any) => {
              closeModalGuardarFiltroCerrado();
            }}
            onConfirm={() => {
              handleClickConfirmFilterButton();
            }}
          >
            <div slot="content">
              <FilterContainer
                title={language.filter.filterName}
                valueFilter={nombreFiltro}
                handleFilterChange={handleChangeFiltroNombre}
              />
            </div>
            <div slot="content">
              <RfUiButton
                disabled={!filterNameAdd}
                text={language.filter.sendConfirm}
                type="button"
                aspect="white"
                className="rf-button"
                onButtonClick={handleClickConfirmFilterButton}
              >
              </RfUiButton>
            </div>
          </RfUiModal>
        </div>
        <div>
          <RfUiModal
            title-Modal={`Usted va a editar el filtro: ${selectedFilterName}`}
            id-modal="moralEdit"
            modal-type={modalCerradoFiltroEditarType}
            required-slot={false}
            onModalClose={() => {
              closeModalEditarFiltroCerrado();
            }}
            onConfirm={() => {
              confirmModalEditarFiltroCerrado(selectedFilterName);
            }}
          >
          </RfUiModal>
        </div>
        <div>
          <RfUiModal
            title-Modal={`¿Esta seguro de que quiere eliminar el filtro? ${selectedFilterName}`}
            id-modal="modalDelete"
            modal-type={modalCerradoFiltroEliminarType}
            required-slot={true}
            onModalClose={(e: any) => {
              closeModalEliminarFiltroCerrado();
            }}
            onConfirm={() => {
              confirmModalEliminarFiltroCerrado();
            }}
          >
          </RfUiModal>
        </div>
      </RfUiAccordionCustom>
    </>
  );
};
